export const initialValues = {
  otp: "",
};
